export class StatusMappingManagementCollections {
  static ModuleName = 'status-mapping';

  static StatusMappings = `${StatusMappingManagementCollections.ModuleName}`;

  static statusMapping(id: string) {
    return `${StatusMappingManagementCollections.StatusMappings}/${id}`;
  }
}
